import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useMemo } from 'react';

import { bimContractSeasonListGql } from '../../bimWorkOrderQueries';

const getBimWorkOrderContraSeasonListId = 'bBimWorkOrderContraSeasonList';

export const useBimWorkOrderContractSeasonList = ({
    contractId,
    withEffect = true,
}: {
    contractId: number | undefined;
    withEffect?: boolean;
}) => {
    const getSeasonListVariables = useMemo(
        () => ({
            contractId,
        }),
        [contractId],
    );

    const [
        bimWorkOrderContractSeasonListData,
        bimWorkOrderContractSeasonListStatus,
        bimWorkOrderContractSeasonListError,
        bimWorkOrderContractSeasonListMakeRequest,
    ] = useRequest({
        requestId: getBimWorkOrderContraSeasonListId,
        query: bimContractSeasonListGql,
        withEffect: withEffect && Boolean(contractId),
        variables: getSeasonListVariables,
    });

    const [bimWorkOrderSeasonSelectionReset] = useResetStoreData({ requestId: getBimWorkOrderContraSeasonListId });

    return useMemo(
        () => ({
            bimWorkOrderSeasonSelectionReset,
            bimWorkOrderContractSeasonListData: bimWorkOrderContractSeasonListData?.bimContractSeasons?.data,
            bimWorkOrderContractSeasonListStatus,
            bimWorkOrderContractSeasonListError,
            bimWorkOrderContractSeasonListMakeRequest,
        }),
        [
            bimWorkOrderContractSeasonListData?.bimContractSeasons?.data,
            bimWorkOrderContractSeasonListError,
            bimWorkOrderContractSeasonListMakeRequest,
            bimWorkOrderContractSeasonListStatus,
            bimWorkOrderSeasonSelectionReset,
        ],
    );
};
